import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SensitiveScopeGroupAlert from 'developer-experience-shared-components/scopes/components/scopesAuthorization/SensitiveScopeGroupAlert';
import ScopesAuthorization from 'developer-experience-shared-components/scopes/v3/components/ScopesAuthorization';
import { extractFQNFromScopeName, getIsAppObjectScopeGroup } from 'developer-experience-shared-components/scopes/v3/utils/appObjects';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { HR } from 'foundations-components/transitional/components/HR';
import { Link } from 'foundations-components/transitional/components/Link';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Small } from 'foundations-components/transitional/components/Small';
import { Tile, TileSection } from 'foundations-components/transitional/components/Tile';
import { View } from 'foundations-components/transitional/components/View';
import { Fragment, useMemo } from 'react';
import { LISTING_STATUS } from '../data/models/ApplicationAuthorization';
import { useFetchAppObjectNames } from '../hooks/queries/useFetchAppObjectNames';
import AppInfoTitle from './AppInfoTitle';
import AuthorizeFooter from './AuthorizeFooter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function renderErrorAlert() {
  return /*#__PURE__*/_jsx(Alert, {
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "oauth.authorization.error.title"
    }),
    type: "danger",
    marginBlock: "400",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "oauth.authorization.error.body"
    })
  });
}
function AuthorizeInfo({
  providerDomain,
  providerName,
  appId,
  authorizationData,
  authorizeStatus,
  listingStatus
}) {
  const appObjectFQNs = useMemo(() => {
    const scopes = authorizationData === null || authorizationData === void 0 ? void 0 : authorizationData.scopeGroups;
    if (scopes) {
      const appObjectScopeNames = new Set();
      scopes.forEach(scope => {
        if (getIsAppObjectScopeGroup(scope.name)) {
          const fqn = extractFQNFromScopeName(scope.name);
          if (fqn) {
            appObjectScopeNames.add(fqn);
          }
        }
      });
      return Array.from(appObjectScopeNames);
    }
  }, [authorizationData]);
  const {
    data: appObjectNames,
    loading
  } = useFetchAppObjectNames({
    names: appObjectFQNs
  });
  const hasAppObjectNamesToFetch = appObjectFQNs && appObjectFQNs.length > 0;

  // on error, do nothing -- we'll just show the internal names
  if (hasAppObjectNamesToFetch && loading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      minHeight: 300
    });
  }
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [authorizeStatus.failed && renderErrorAlert(), /*#__PURE__*/_jsxs(Tile, {
      marginBlockStart: "600",
      children: [/*#__PURE__*/_jsxs(TileSection, {
        children: [/*#__PURE__*/_jsx("span", {
          "data-test-id": "authorize-title",
          children: /*#__PURE__*/_jsx(AppInfoTitle, {
            providerDomain: providerDomain,
            providerName: providerName,
            appId: appId,
            showCertificationIcon: listingStatus === LISTING_STATUS.CERTIFIED
          })
        }), /*#__PURE__*/_jsx(HR, {}), authorizeStatus.succeeded && /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("b", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "developer-experience-shared-components.scopesAuthorization.appIsRequestingAccess"
            })
          }), /*#__PURE__*/_jsx(SensitiveScopeGroupAlert, {
            requestedScopes: authorizationData.scopeGroups
          }), /*#__PURE__*/_jsx(View, {
            marginBlockStart: "600",
            as: "div",
            children: /*#__PURE__*/_jsx(ScopesAuthorization, {
              scopes: authorizationData.scopeGroups,
              appObjectNames: appObjectNames
            })
          })]
        })]
      }), /*#__PURE__*/_jsx(AuthorizeFooter, {})]
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "200",
      as: "div",
      children: /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "oauth.authorization.recaptcha.protected_jsx",
          elements: {
            Link
          },
          options: {
            privacyHref: 'https://policies.google.com/privacy',
            tosHref: 'https://policies.google.com/terms'
          }
        })
      })
    })]
  });
}
export default AuthorizeInfo;